<template>
<el-dialog
  :visible='true'
  title=''
  :before-close='handleClose'
  width='940px'
>
  <div class="notShow">
    <img :src="tipList[type-1]" alt="示例图">
  </div>
</el-dialog>
</template>

<script>

export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  type:{
    type:Number,
    default:0
  }
 },
 data() {
 return {
  tipList:[
    require("@/assets/images/backstage/cardPic.png"),
    require("@/assets/images/backstage/cardVideo.png"),
    require("@/assets/images/backstage/cardPics.png"),
    require("@/assets/images/backstage/cardRed.png"),
    require("@/assets/images/backstage/cardGoods.png"),
  ],
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  toSubmit() {
    // 跳转至  后台管理-富信资质
    this.$router.push({ name: 'media_qualification' })
  },
 }
}
</script>
<style lang='scss'>
::v-deep .el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}

</style>
<style lang='scss' scoped>

/deep/ .el-dialog__header{
  border-bottom:none;
}
/deep/ .el-dialog__body{
  padding-top: 0;
}

.notShow {
  position: relative;
  text-align: center;
  top:-10px;
  img {
    width: 100%;
    // height: 348px;
  }
}
</style>